import { useState, useEffect } from 'react';
import {
    useGetOne,
    useRecordContext
} from 'react-admin';
import { useFormContext } from "react-hook-form"
import {
    Grid,
    Box,
} from '@mui/material';
import DOMPurify from 'dompurify';
import {hostUrl} from "../../../utils/url-manager";

export const NokEmailPreview = () => {
    const record = useRecordContext();
    const { watch } = useFormContext();
    const [loading, setLoading] = useState<boolean>(false);
    const activeSignature = watch('nokEmailSignature');
    const activeTemplate = watch('nokEmailTemplate');


    const { data: signature, isPending, error } = useGetOne(
        'nok_email_signatures',
        {
            id: activeSignature
        }
    );
    const { data: persona } = useGetOne(
        'nok_personas',
        {
            id: record?.nokPersonas?.[0] ?? ''
        }
    );

    const { data: emailTemplate } = useGetOne(
        'nok_email_templates',
        {
            id: activeTemplate
        }
    );

    if (!activeSignature || !emailTemplate || !persona) {
        return null;
    }


    function parseHtmlVariables(): string {
        let currentHtml: string = emailTemplate.html;
        let signatureHtml: string = signature.html;
        const placeholderImages: string[] = [
            hostUrl + 'images/admin/nok/email/signature/defaults/female-placeholder.png',
            hostUrl + 'images/admin/nok/email/signature/defaults/male-placeholder.png'
        ];
        const randomNum: number = Math.floor(Math.random() * placeholderImages.length);
        const tempImage: string = placeholderImages[randomNum];

        if (signatureHtml.includes('{{persona_name}}')) {
            const nme = persona?.name ?? 'Name - Not Set';
            const nameString: string = `<span>${nme}</span>`
            signatureHtml = signatureHtml.replace('{{persona_name}}', nameString );
        }
        if (signatureHtml.includes('{{persona_image}}')) {
            const nme = persona?.name ?? 'Name - Not Set';
            const personaImage = persona?.image?.src ?? tempImage;

            const imgString: string = `<img src="${personaImage}" alt="${nme}" style="width: 100%;height:auto;max-width: 100%;" />`;
            signatureHtml = signatureHtml.replace('{{persona_image}}', imgString );
        }
        if (signatureHtml.includes('{{persona_email}}')) {
            const em = persona?.email ?? 'Email - Not Set';
            const emailString: string = `<a href="mailto:${em}" 
                                    style="color:inherit;text-decoration:inherit;font-size:inherit;font-weight:inherit">
                                    ${em}</a>`
            signatureHtml = signatureHtml.replace('{{persona_email}}', emailString );
        }
        if (signatureHtml.includes('{{persona_title}}')) {
            const tle: string = persona?.jobTitle ?? 'Job title - Not Set';
            const titleString: string = `<span>${tle}</span>`;
            signatureHtml = signatureHtml.replace('{{persona_title}}', titleString );
        }
        if (signatureHtml.includes('{{persona_telephone}}')) {
            const num: string = persona?.phone ?? 'Tel - Not Set';
            const phoneString: string = `<a href="tel:${num}" 
                                    style="color:inherit;text-decoration:inherit;font-size:inherit;font-weight:inherit">
                                    ${num}</a>`;
            signatureHtml = signatureHtml.replace('{{persona_telephone}}', phoneString );
        }
        if (signatureHtml.includes('{{nok_company_logo}}')) {
            const img: string = record?.logo?.src ?? `${hostUrl}images/admin/nok/nn-logo-white.png`;
            const cmpy: string = record?.name;
            const imgString: string = `<img src="${img}" alt="${cmpy}" style="width: 100%;height:auto;max-width: 100%;" />`;
            signatureHtml = signatureHtml.replace('{{nok_company_logo}}', imgString );
        }
        if (signatureHtml.includes('{{nok_url}}')) {
            const url: string = record?.url ?? 'https://noknok.ai';
            const urlString: string = `<a href="${url}" 
                                    target="_blank"
                                    style="color:inherit;text-decoration:inherit;font-size:inherit;font-weight:inherit">
                                    ${url}</a>`
            signatureHtml = signatureHtml.replace('{{nok_url}}', urlString );
        }
        if (currentHtml.includes('{{nok_name}}')) {
            currentHtml = currentHtml.replace('{{nok_name}}', 'Nok Nok Ltd' );
        }
        if (currentHtml.includes('{{email_content}}')) {
            const contentString: string = `
                <p>Hello Lorem,</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam egestas vitae eros non cursus. Suspendisse potenti. Donec at magna est. Morbi sit amet molestie diam. Phasellus eu rhoncus turpis. Nulla scelerisque tellus vel placerat fringilla. Donec enim turpis, fringilla ac volutpat non, consectetur finibus erat. Etiam auctor magna massa, non molestie nisl cursus vel. Sed pulvinar ligula nulla, eget egestas lorem porttitor et. Duis nec lectus enim.</p>
                <p>Curabitur eget velit sed nunc tempus faucibus. Integer risus diam, euismod eget leo eget, euismod cursus metus. Integer nunc lorem, iaculis a dolor sed, mollis accumsan nisi. Nulla auctor sodales eleifend.</p>
                <p>Kind regards,</p>
            `;
            currentHtml = currentHtml.replace('{{email_content}}', contentString );
        }
        if (currentHtml.includes('{{email_signature}}')) {
            currentHtml = currentHtml.replace('{{email_signature}}', signatureHtml);
        }
        return currentHtml;
    }


    return (
        <Box sx={ { width: '100%' } }>
            { (isPending) &&
                <Box>
                    <span>{ "Loading Preview..." }</span>
                </Box>
            }
            { (error) &&
                <Box>
                    <span>{ "Something has gone wrong loading the preview" }</span>
                </Box>
            }
            { (signature) &&
                <Box sx={ {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                } } >
                    <span>{ "Email Preview" }</span>
                    <span>{ "Note: 'Not Set' values won't appear on the sent email" }</span>
                    <Box sx={ {
                        width: '100%',
                        height: '100%',
                        background: '#fff'
                    } }>

                        <div style={ { width: '100%', maxWidth: '100%', display: 'flex', color: 'black' } } dangerouslySetInnerHTML={ { __html: parseHtmlVariables() } }  />
                    </Box>
                </Box>

            }
        </Box>
    );
}